import { useContext, useEffect } from 'react'
import { AuthContext } from '@/context/auth-context'
import { useAppDispatch, useAppSelector } from '@/store/store-hooks'
import { RootState } from '@/store/store'
import { CircularProgressContinuous } from '@/components/loaders/CircularProgressContinuous'
import SubscriptionDetails from '@/account/components/SubscriptionDetails'
import { AccountActions } from '@/account/store/slice'
import { SettingsPanelShell } from '../components/SettingsPanelShell'

/**
 * Subscription section (individual accounts): reuses SubscriptionDetails, which already renders plan,
 * price, cadence, and discount states from the account store. SubscriptionDetails does not fetch, so
 * this panel triggers the payment-details refresh on mount (mirroring the legacy AccountPage).
 */
export function SubscriptionPanel() {
  const dispatch = useAppDispatch()
  const { userAccountData } = useContext(AuthContext)
  const canViewSubscriptionInfo = userAccountData?.canViewStripeSubscriptionInfo

  const isLoading = useAppSelector((state: RootState) => state.accountState.loading)
  const isInitialLoadComplete = useAppSelector((state: RootState) => state.accountState.initialLoadComplete)
  const showLoader = isLoading && !isInitialLoadComplete

  useEffect(() => {
    if (canViewSubscriptionInfo) {
      dispatch(AccountActions.refreshPaymentDetails({ forceRefresh: true }))
    }
  }, [userAccountData, canViewSubscriptionInfo, dispatch])

  return (
    <SettingsPanelShell title="Subscription">
      {showLoader ? (
        <div className="flex min-h-[40vh] items-center justify-center">
          <CircularProgressContinuous />
        </div>
      ) : (
        <SubscriptionDetails />
      )}
    </SettingsPanelShell>
  )
}
